import React from 'react';
import {
  Button,
  Checkbox,
  FormControl,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  VStack,
} from '@chakra-ui/react';

interface QuoteFormProps {
  data: Record<string, any>;
  options: Record<string, any[]>;
  onChange: (data: Record<string, any>) => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}

export default function QuoteForm({
  data,
  options,
  onChange,
  onSubmit,
  isSubmitting,
}: QuoteFormProps) {
  const set = (key: string, value: any) => onChange({ ...data, [key]: value });

  return (
    <VStack align="stretch" spacing={3}>
      <SimpleGrid columns={2} spacing={3}>
        <FormControl>
          <FormLabel fontSize="xs">Type</FormLabel>
          <Select
            size="sm"
            value={data.type ?? ''}
            onChange={(e) => set('type', e.target.value)}
          >
            {options.types?.map((t: any) => (
              <option key={t.value} value={t.value}>
                {t.label}
              </option>
            ))}
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel fontSize="xs">Theme (Carrier)</FormLabel>
          <Select
            size="sm"
            value={data.theme ?? ''}
            onChange={(e) => set('theme', e.target.value)}
          >
            {options.themes?.map((t: any) => (
              <option key={t.value} value={t.value}>
                {t.label}
              </option>
            ))}
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel fontSize="xs">Pay Cycle</FormLabel>
          <Select
            size="sm"
            value={data.pay_cycle ?? ''}
            onChange={(e) => set('pay_cycle', e.target.value)}
          >
            {options.pay_cycles?.map((t: any) => (
              <option key={t.value} value={t.value}>
                {t.label}
              </option>
            ))}
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel fontSize="xs">Cutoff</FormLabel>
          <Checkbox
            size="sm"
            isChecked={data.cutoff ?? false}
            onChange={(e) => set('cutoff', e.target.checked)}
          >
            Enable cutoff
          </Checkbox>
          {data.cutoff && (
            <Input
              size="sm"
              mt={1}
              type="number"
              step="any"
              placeholder="Cutoff value"
              value={data.cutoff_value ?? ''}
              onChange={(e) => set('cutoff_value', Number(e.target.value))}
            />
          )}
        </FormControl>
      </SimpleGrid>

      <Button
        colorScheme="purple"
        size="sm"
        onClick={onSubmit}
        isLoading={isSubmitting}
        alignSelf="flex-start"
      >
        Create Quote
      </Button>
    </VStack>
  );
}
